"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var AcceptPolicy = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var lang = (0, next_intl_1.useLocale)();
    var config = (0, swr_hooks_1.useConfig)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.acceptTerms },
        t('byClickAcceptTerms'),
        ' ',
        react_1.default.createElement(ui_components_1.TextLink, { href: generateUrlWithLang((config === null || config === void 0 ? void 0 : config.generalTermsAndConditionsLink) || '/terms-of-use'), target: "_blank" }, t('theTermsAndConditions')),
        ', ',
        react_1.default.createElement(ui_components_1.TextLink, { href: "".concat(lang, "/privacy-policy"), target: "_blank" }, t('privacyPolicy'))));
};
exports.default = AcceptPolicy;
